import http from "../../../service/axios/httpRequest";
import { logout } from "../../../service/localStorage/localStorage";


export const getChartsRequest = async () => {
     return await http.get("/bff/charts-bff/admin").then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               throw err;
          });
}

export const getAiCreditsRequest = async ({ users, startDate, endDate } = {}) => {
     const params = {};
     if (users) params.users = users;
     if (startDate) params.startDate = startDate;
     if (endDate) params.endDate = endDate;

     return await http.get("/bff/ai-credits-bff/user-credits", { params }).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               throw err;
          });
}